import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, HtmlRaw, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { QUIZ_DETAILS_GET } from '../../../../app/redux/actions/tutors';
import { InfoWrapper } from './style';
import { convertDuration } from '../../../../utils/common';
import { CustomBox, InnerBox } from '../../../components/Tutor/style';
import CustomToggle from '../../CustomToggle';

export const ModalPreviewQuizId = 'ModalPreviewQuiz';

const ModalPreviewQuiz = ({
  isEvent,
  mediaIsPhone,
  payload,
  id,
  quizDetails,
  getQuizDetails,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);

  useEffect(() => {
    if (id === ModalPreviewQuizId) {
      getQuizDetails(payload?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Modal
      title="Anteprima quiz"
      modalId={ModalPreviewQuizId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{
          maxWidth: `${mediaIsPhone ? 'var(--full-width)' : 'min(80vw, 1116px)'}`,
          minHeight: '50vh',
        }}
      >
        <Text type="b3" mb={32}>
          Di seguito i valori assegnati al quiz.
        </Text>
        <InfoWrapper>
          <div>
            <Text type="h3" mb={8}>
              Titolo quiz
            </Text>
            <Text type="b4">{quizDetails.title}</Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Percentuale di superamento
            </Text>
            <Text type="b4">{quizDetails.percentage}%</Text>
          </div>
          {isEvent && (
            <div>
              <Text type="h3" mb={8}>
                Numero di tentativi
              </Text>
              <Text type="b4">{quizDetails.quiz_tentatives}</Text>
            </div>
          )}
          <div>
            <Text type="h3" mb={8}>
              Durata
            </Text>
            <Text type="b4">{convertDuration(quizDetails.duration)}</Text>
          </div>
        </InfoWrapper>
        <Text type="h3" mb={8}>
          Descrizione
        </Text>
        <Text type="b4" mb={40}>
          {quizDetails.description}
        </Text>
        {(quizDetails.choice_elements || []).map((q, qi) => (
          <CustomBox key={`question-${qi}`} className="mb-4">
            <Text type="h3" className="mandatory" mb={16}>
              Domanda {qi + 1}
            </Text>
            <Text type="b4" mb={24}>
              <HtmlRaw html={q?.question} />
            </Text>
            {(q?.choice_answers || []).map((a, ai) => (
              <InnerBox key={`answer-${qi}_${ai}`} className="mb-4">
                {mediaIsPhone && (
                  <Text type="h3" mb={16}>
                    Risposta {ai + 1}
                  </Text>
                )}
                <div className="d-flex g-24 mb-3">
                  {!mediaIsPhone && <Text type="h3">Risposta {ai + 1}</Text>}
                  <Text type="b3" tag="label" htmlFor={`correct-answer-${ai}`}>Risposta corretta</Text>
                  <CustomToggle id={`correct-answer-${ai}`} checked={a?.is_correct} disabled />
                </div>
                <Text type="b4">
                  <HtmlRaw html={a?.answer} />
                </Text>
              </InnerBox>
            ))}
          </CustomBox>
        ))}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="Chiudi"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
      </Footer>
    </Modal>
  );
};

ModalPreviewQuiz.propTypes = {
  isEvent: PropTypes.bool,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  payload: PropTypes.object,
  id: PropTypes.string,
  quizDetails: PropTypes.object,
  // dispatch
  getQuizDetails: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { payload, id } = state.app.modal;
      const { preview: quizDetails } = state.tutors.quiz;
      return { payload, id, quizDetails };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getQuizDetails: (id) => dispatch({ type: QUIZ_DETAILS_GET._REQUEST, id }),
    })
  ),
  withMediaQueries
)(ModalPreviewQuiz);
